@import "~animatewithsass/animate.scss";

@mixin container {
  border-bottom-right-radius: 10px;
  border-top-right-radius: 10px;
  height:100% !important;
}

@mixin container-machine-settings {
  border-bottom-right-radius: 10px;
  border-top-right-radius: 10px;
  height:100% !important;
}

@mixin content {
  border-radius: 10px;
}

@mixin containers($contentName){
  .container-fluid-#{$contentName}{
    @if($contentName == machine-settings){
      @include container-machine-settings;
    }
    @else{
      @include container;
    }
    .#{$contentName} {
      @include content;
    }
  }
}

.nav-routes {
  @include containers(machine-settings);
  @include containers(display-and-keyboard);
  @include containers(timers);
  @include containers(hardware-setup);
  @include containers(miscellaneous);
  .fade-in {
    @include fadeIn($duration: 1s,
    $delay: .2s,
    $function: ease,
    $fill: both);
  }
  height:100% !important;
  box-sizing: border-box !important;
  -moz-box-sizing: border-box !important;

}


// WEBPACK FOOTER //
// webpack:///var/jenkins_home/workspace/azure-prod-baristadj-server/src/app/components/settings/settings-routes/settings-routes.scss